import React, { useState, useEffect, useRef } from "react";
import GoogleAds from "./GoogleAds";

const MainScreenComponent = (props) => {
  const { handleNewChat } = props;
  const [height, setHeight] = useState(window.innerHeight);
  const containerRef = useRef(null);

  // Update height on window resize
  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setHeight(containerRef.current.clientHeight);
      }
    };

    window.addEventListener('resize', handleResize);
    // Initial measurement after component mounts
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        gap: "10px",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <p style={{ textAlign: "center" }}>不過錯過任何一個交易通知<br />立即下載 DCFever 二手買賣 APP!</p>
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <a href="https://apps.apple.com/us/app/dcfever-%E4%BA%8C%E6%89%8B%E5%B8%82%E9%9B%86/id6444018317" target="_blank">
            <img src="https://www.dcfever.com/campaigns/2023/test/appdownload_appstore.png" alt="App Download" width="180" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.dcfever.tradingapp" target="_blank">
            <img src="https://www.dcfever.com/campaigns/2023/test/appdownload_googleplay.png" alt="App Download" width="180" />
          </a>
        </div>
      </div>
      {/* {height >= 500 && <GoogleAds width={336} height={280} />} */}
      <img src="https://www.dcfever.com/articles/news/2023/10/20231004_qrcode_03.png" alt="QR Code" width="200" />
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <p>以手機掃描 QR Code 下載 DCFever 二手買賣 APP</p>
      </div>
    </div>
  );
};

export default MainScreenComponent;
